import reqProduto from "../../../../services/reqMultiTenant/reqProduto";
import MainReportMatrix from "../../matrix";
import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";

const ReportEstoqueBaixoGrade = () => {
	const options = {
		title: "Estoque Baixo - Grade",
		subTitle: "Produtos grade com estoque abaixo ou igual ao crítico, exibindo pai e variações",
		ident: "estoqueBaixoGrade",
		identFilter: "filterEstoqueBaixoGrade",
		identReport: "reportEstoqueBaixoGrade",
		tableColumns: [
			{ key: "nome_pai", label: "Produto Base", align: "left" },
			{ key: "nome_variacao", label: "Variação", align: "left" },
			{ key: "qtatual", label: "Estoque", align: "center" },
			{ key: "qtcritica", label: "Estoque Mín.", align: "center" },
			{ key: "valor", label: "Valor", align: "center", format: "currency" },
		],
		reportColumns: [
			{ key: "nome_pai", label: "Produto Base", align: "left" },
			{ key: "nome_variacao", label: "Variação", align: "left" },
			{ key: "qtatual", label: "Estoque", align: "center" },
			{ key: "qtcritica", label: "Estoque Mín.", align: "center" },
			{ key: "valor", label: "Valor", align: "right", format: "currency" },
		],
		showTime: false,
		hasActive: false,
		hasSaleType: false,
		parametersDate: [{ id: 1, label: "Filtro", value: "snapshot" }],
		parametersFilter: [
			{ id: 1, label: "Produto Base", value: "nome_pai" },
			{ id: 2, label: "Variação", value: "nome_variacao" },
		],
		listDataTotal: [],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };
		return reqProduto.listLowStockGrade(newFilterData);
	};

	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens} />
		</div>
	);
};

export default ReportEstoqueBaixoGrade;
